import EnhancedRoutePlanList from "./EnhancedRoutePlanList";
import EnhancedRoutePlanCreate from "./EnhancedRoutePlanCreate";
import AiRoutePlannerIcon from "../../components/icons/AiRoutePlannerIcon";
import EnhancedRoutePlanShow from "./EnhancedRoutePlanShow";
import EnhancedRoutePlanEdit from "./EnhancedRoutePlanEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "enhancedBusSchedulePlans",
  list: EnhancedRoutePlanList,
  create: EnhancedRoutePlanCreate,
  show: EnhancedRoutePlanShow,
  edit: EnhancedRoutePlanEdit,
  icon: AiRoutePlannerIcon,
};
